export var MULTILINGUAL_NAMESPACE = 'multilingual';
export function getLocaleNamespace(locale) {
    return "".concat(MULTILINGUAL_NAMESPACE, "_").concat(locale);
}
//# sourceMappingURL=getLocaleNamespace.js.map